import React from 'react';
import Reflux from 'reflux';
import role from 'shared/lib/role';
import { Map, OrderedMap } from 'immutable';
import PureRenderMixin from 'react-pure-render/mixin';
import CuesheetRowActions from 'flux/actions/cuesheet/CuesheetRowActions';
import NewGlobalElementModalActions from 'flux/actions/NewGlobalElementModalActions';
import PublishGlobalElementsActions from 'flux/actions/PublishGlobalElementsActions';
import ModalActions from 'flux/actions/ModalActions';
import ConfirmActions from 'flux/actions/ConfirmActions';
import UserSessionStore from 'flux/stores/UserSessionStore';
import GlobalElementStore from 'shared/flux/stores/GlobalElementStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import MessageConstants from 'shared/constants/Messages';
import UIRegions from 'shared/constants/UIRegions';
import RouteActions from 'shared/flux/actions/RouteActions';
import RoleHelper from 'shared/lib/role';
import { hasGlobalElementsFullAccess } from 'shared/lib/permission';
import TeamViewStore from 'flux/stores/TeamViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';

import { isMac } from 'shared/lib/platformCheck';
import KeyModifierConstants from 'shared/constants/KeyModifierConstants.jsx';

export default React.createClass({
  displayName: 'GlobalElementRowMenu',

  mixins: [
    Reflux.connect(TeamViewStore, 'team'),
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connect(GlobalElementStore, 'globalElement'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connectFilter(CuesheetStore, 'rowSelectionMode', (state) =>
      state.get('rowSelectionMode'),
    ),
    PureRenderMixin,
  ],

  propTypes: {
    item: React.PropTypes.any.isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const { item } = this.props;
    const { popoverVisibility, team, user, rowSelectionMode } = this.state;
    const { teamId } = this.context.router.state.params;

    const isTeamAdmin = RoleHelper.hasTeamAdminRole(user, teamId);
    const hasGlobalElementsPermission = hasGlobalElementsFullAccess(
      team.get('permissions'),
    );

    if (
      !hasGlobalElementsPermission ||
      rowSelectionMode ||
      !isTeamAdmin ||
      !item ||
      !item.get('globalElement')
    )
      return null;

    const showGlobalElementRowMenu = popoverVisibility.get(
      this._getPopoverId(),
    );

    return (
      <PopoverMenu config={this._getConfig()} show={showGlobalElementRowMenu} />
    );
  },

  _getPopoverId() {
    const { item } = this.props;
    return `${item.get('_id')}_globalElementMenu`;
  },

  _getConfig() {
    /**
     * An item in the items field can have a "type" of: link, divider, custom
     *  * link - standard dropdown link
     *  * divider - represents a divider line
     *  * custom - respresents a custom component
     */

    const id = this._getPopoverId();

    return Map({
      id,
      icon: 'globe row-menu-ge pointer',
      title: <span>GLOBAL ELEMENT MENU</span>,
      placement: 'right',
      onClick: () => PopoverActions.show(id),
      onHide: () => PopoverActions.hide(id),
      items: OrderedMap({
        retrieveLatestVersion: Map({
          content: (
            <span>
              Retrieve Latest GE Changes{' '}
              {this._getKeyModifier('retrieveLatestGE')}
            </span>
          ),
          onClick: () => this._handleRetrieveLatestVersionClick(),
        }),
        publishCurrentVersion: Map({
          content: (
            <span>
              Publish current version to GE Manager{' '}
              {this._getKeyModifier('saveGEVersion')}
            </span>
          ),
          onClick: () => this._handlePublishCurrentClick(),
        }),
        publishCurrentVersionEverywhere: Map({
          content: (
            <span>
              Publish current version everywhere{' '}
              {this._getKeyModifier('publishGEEverywhere')}
            </span>
          ),
          onClick: () => this._handlePublishEverywhereClick(),
        }),
        saveNewGE: Map({
          content: (
            <span>
              Save as new global element {this._getKeyModifier('saveAsNewGE')}
            </span>
          ),
          onClick: () => this._handleSaveNewClick(),
        }),
        convertRow: Map({
          content: 'Convert to normal item row',
          onClick: () => this._handleConvertRowClick(),
        }),
        goToGEEditor: Map({
          content: 'Go to global element editor',
          onClick: () => this._handleGoToEditorClick(),
          divider: true,
        }),
        publishCurrentVersionsToAll: Map({
          content: <span>Bulk update all global elements to the manager</span>,
          onClick: () => this._handlePublishAllCurrentClick(),
        }),
      }),
    });
  },

  _getKeyModifier(type) {
    const command = isMac()
      ? KeyModifierConstants.macKeys[type]
      : KeyModifierConstants.windowsKeys[type];
    return <span className="shortcut-key-modifier">{command}</span>;
  },

  _handlePublishEverywhereClick() {
    const { item } = this.props;

    ModalActions.show(UIRegions.PublishGEChanges);
    PublishGlobalElementsActions.populateForShowRow(item.get('globalElement'));
  },

  _handleRetrieveLatestVersionClick() {
    const { teamId, eventId, showId } = this.context.router.state.params;

    ConfirmActions.prompt(
      MessageConstants.retrieveLatestGlobalElementChanges,
      () =>
        CuesheetRowActions.retrieveLatestGlobalElementVersion(
          teamId,
          eventId,
          showId,
          this.props.rowIndex,
        ),
    );
  },

  _handlePublishAllCurrentClick() {
    ConfirmActions.prompt(
      MessageConstants.publishAllShowRowChangesToGlobalElementManager,
      () => CuesheetRowActions.publishAllShowRowChangesToGlobalElementManager(),
    );
  },

  _handlePublishCurrentClick() {
    const { teamId, eventId, showId } = this.context.router.state.params;
    CuesheetRowActions.publishShowRowChangesToGlobalElementRow(
      teamId,
      eventId,
      showId,
      this.props.rowIndex,
    );
  },

  _handleConvertRowClick() {
    const { teamId, eventId, showId } = this.context.router.state.params;
    CuesheetRowActions.removeGlobalElementReference(
      teamId,
      eventId,
      showId,
      this.props.rowIndex,
    );
  },

  _handleSaveNewClick() {
    NewGlobalElementModalActions.populate([this.props.rowIndex]);
  },

  _handleGoToEditorClick() {
    const { globalElement } = this.state;

    RouteActions.goToGlobalElementManager({
      teamId: globalElement.get('teamId'),
      eventId: globalElement.get('eventId'),
      showId: globalElement.get('showId'),
    });
  },

  _hasEventAdminRole() {
    const { teamId, eventId } = this.context.router.state.params;
    return role.hasEventAdminRole(this.props.user, teamId, eventId);
  },
});
